import { map, sortBy } from 'lodash'

export const getTermOptions = (terms = []) =>
  map(terms, ({ name, _id, startDate, endDate }) => ({
    title: name,
    key: _id,
    startDate,
    endDate,
  }))

// return district options for state/sau sorted by name
export const getDistrictOptions = (districts = []) => {
  const districtOptions = map(districts, ({ _id, name }) => ({
    key: _id,
    title: name,
  }))
  return sortBy(districtOptions, 'title')
}
